import { render, staticRenderFns } from "./TotalSellToBuyRatio.vue?vue&type=template&id=66a4eaf6&"
import script from "./TotalSellToBuyRatio.vue?vue&type=script&lang=js&"
export * from "./TotalSellToBuyRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports